export default __webpack_public_path__ + "static/media/icon_policy_overview_step3-1.d2021e8e.svg";